import { VoucherFormBanner } from '../../components/VoucherForm/Banner';
import { VoucherFormBooking } from '../../components/VoucherForm/Booking';
import VoucherFormComments from '../../components/VoucherForm/Comment/VoucherFormComments';
import { VoucherFormProvider } from '../../components/VoucherForm/Context';
import { VoucherFormDiscount } from '../../components/VoucherForm/Discount';
import { VoucherFormInformation } from '../../components/VoucherForm/Information';
import { VoucherFormQuantity } from '../../components/VoucherForm/Quantity';
import { VoucherFormRulesTitle } from '../../components/VoucherForm/Rules';
import VoucherFormCustomer from '../../components/VoucherForm/Rules/AllowedCustomer/VoucherFormCustomer';
import { VoucherFormCountriesAndLines } from '../../components/VoucherForm/Rules/CountriesAndLines';
import { VoucherFormTrips } from '../../components/VoucherForm/Rules/Trips';
import { VoucherFormStructure } from '../../components/VoucherForm/Structure';
import { VoucherFormSubmit } from '../../components/VoucherForm/Submit';

import styles from './add-voucher.module.scss';

const AddGoodwillPage = () => {
  const VoucherFormInformationTemplate = {
    revenueType: 'Marketing',
    voucherType: 'Goodwill',
    reasonField: true,
    specificationLabel: 'Specification (Booking/ride no.)',
    specificationRequired: true,
  };

  const VoucherFormStructureTemplate = {
    prefix: 'CUSKU',
    length: 12,
  };

  const VoucherFormDiscountTemplate = {
    disabled: false,
    discountType: 'value_marketing',
    showFreeAncillaries: true,
    excludeTypes: ['free_ride_hybrid', 'credit_amount', 'value_hybrid'],
  };

  const VoucherFormBookingTemplate = {
    usageType: 'single',
    disableAllowedPlatforms: false,
    disableValidity: true,
  };

  const VoucherFormQuantityTemplate = {
    disabled: true,
  };

  const VoucherFormTripsTemplate = {
    hideMinimumTicketsAmount: true,
    hideMinimumValue: true,
  };

  const VoucherFormCountriesAndLinesTemplate = {
    allowedCountries: false,
    transportType: true,
  };

  return (
    <>
      <VoucherFormBanner title='Customer Service - Goodwill' />
      <VoucherFormProvider>
        <form>
          <div className={styles.container}>
            <VoucherFormInformation template={VoucherFormInformationTemplate} />
            <VoucherFormQuantity template={VoucherFormQuantityTemplate} />
            <VoucherFormStructure template={VoucherFormStructureTemplate} />
            <VoucherFormDiscount template={VoucherFormDiscountTemplate} />
            <VoucherFormBooking template={VoucherFormBookingTemplate} />
          </div>
          <div className={styles.container}>
            <VoucherFormRulesTitle />
            <VoucherFormCustomer />
            <VoucherFormTrips template={VoucherFormTripsTemplate} />
            <VoucherFormCountriesAndLines template={VoucherFormCountriesAndLinesTemplate} />
          </div>
          <div className={styles.container}>
            <VoucherFormComments />
          </div>
          <VoucherFormSubmit />
        </form>
      </VoucherFormProvider>
    </>
  );
};

export default AddGoodwillPage;
